<template>
  <div class="report-filter-group">
    <h4 v-if="label">{{label}}</h4>
    <div class="sub-title" v-if="subTitle">{{subTitle}}</div>
    <slot />
  </div>
</template>

<style scoped>
.report-filter-group {
  margin-bottom: 1.75rem;
}
.report-filter-group > h4 {
  margin-bottom: 0.25rem;
}
.report-filter-group > .sub-title {
  margin-top: -0.25rem;
  margin-bottom: 0.75rem;
  font-size: 85%;
  color: #787878;
}
</style>


<script>
export default {
  name: 'ReportFilterGroup',
  props: {
    label: String,
    subTitle: String
  }
}
</script>